module.exports = {
      id: "gzhome-usage",
      viewBox: "0 0 29.037 17.12",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#gzhome",
      toString: function () {
        return this.url;
      }
    }